<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="dialog = true" depressed>新しい{{ $route.name }}を作成</v-btn>
      </section>

      <v-card flat>
        <v-card-title>
          <v-row>
            <v-col cols="6" md="3">
              <v-text-field
                v-model="filterKeyword.name"
                label="氏名"
                outlined clearable hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :headers="tableHeaders"
          :items="filterItems"
          :sort-by="['updatedAt']"
          :sort-desc="[true]"
          :loading="loading"
          :search="search"
          @click:row="onRowClick">
            <template v-slot:item="{ item }">
              <tr :class="item.enabled ? '' : 'disabled'" @click="onRowClick(item)">
                <td>{{ item.name }}</td>
                <td>{{ item.department }}</td>
                <td>{{ item.email }}</td>
                <td class="text-end">
                  <template v-if="item.paidRemain != null">{{ item.paidRemain }} 日</template>
                </td>
                <td class="text-end">
                  <template v-if="item.paidHoursUsed != null">{{ item.paidHoursUsed }} h</template>
                </td>
                <td>
                  <template v-for="(value, index) in item.corporateIDs">
                    <v-chip :key="index" small label dark color="orange" class="mr-2">{{ getCorporateLabel(value) }}</v-chip>
                  </template>
                </td>
                <td>
                  <v-chip v-for="(value, index) in item.role" :key="index" small label dark color="light-blue darken-3" class="mr-2">{{ value }}</v-chip>
                </td>
                <td>{{ getDateTime(item.updatedAt) }}</td>
              </tr>
            </template>
        </v-data-table>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" width="600" class="edit-dialog" fixed temporary right stateless>
        <v-card flat class="drawer-card">
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="10" class="pa-2">
                  <v-text-field
                    ref="email"
                    label="e-mail"
                    type="email"
                    v-model="editedItem.email"
                    :rules="[rules.required, rules.email, existsEmail]"
                    class="required"
                    :disabled="this.editedIndex > 0"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="2" class="pa-2">
                  <v-btn @click="resendConfirm" class="py-7" text>
                    <v-icon>far fa-paper-plane</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="pa-2" v-if="this.editedIndex === -1">
                  <v-text-field
                    ref="passwd"
                    label="パスワード"
                    type="password"
                    v-model="editedItem.passwd"
                    :rules="[rules.required, rules.min8Char]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field
                    ref="last"
                    label="姓"
                    v-model="editedItem.last"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field
                    ref="first"
                    label="名"
                    v-model="editedItem.first"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="tel"
                    label="電話番号(ハイフンあり)"
                    type="tel"
                    v-model="editedItem.phone"
                    :rules="[rules.tel]"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-menu
                    v-model="birthday"
                    :close-on-content-click="false"
                    :nudge-right="0"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        ref="birthday"
                        label="生年月日"
                        v-model="editedItem.birthday"
                        v-on="on"
                        outlined clearable hide-details="auto">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.birthday" @input="birthday = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-combobox
                    ref="department"
                    label="所属部署"
                    v-model="editedItem.department"
                    :items="departments"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('department', true)"
                    readonly outlined clearable hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="director"
                    label="役職"
                    v-model="editedItem.director"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-menu
                    v-model="joinDate"
                    :close-on-content-click="false"
                    :nudge-right="0"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        ref="joinDate"
                        label="入社日"
                        v-model="editedItem.joinDate"
                        v-on="on"
                        outlined clearable hide-details="auto">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.joinDate" @input="joinDate = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-combobox
                    ref="unitPrice"
                    label="時間単価"
                    v-model="editedItem.unitPrice"
                    :items="unitPrices"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('unitPrice', false)"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="3" class="pa-2">
                  <v-combobox
                    ref="employmentType"
                    label="雇用形態"
                    v-model="editedItem.employmentType"
                    :items="employmentTypes"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('employmentType', false)"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="3" class="pa-2">
                  <v-text-field
                    ref="paidRemain"
                    label="有給残日数"
                    v-model="editedItem.paidRemain"
                    :rules="[rules.min0]"
                    type="number"
                    min="0"
                    suffix="日"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="3" class="pa-2">
                  <v-text-field
                    ref="paidHoursUsed"
                    label="使用済時間有給"
                    v-model="editedItem.paidHoursUsed"
                    :rules="[rules.min0]"
                    type="number"
                    min="0"
                    suffix="時間"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="3" class="pa-2">
                  <v-text-field
                    ref="dailyWorktime"
                    label="1日の労務時間"
                    v-model="editedItem.dailyWorktime"
                    :rules="[rules.min0]"
                    type="number"
                    min="0"
                    suffix="時間"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-combobox
                    ref="corporates"
                    label="所属企業"
                    v-model="editedItem.corporateIDs"
                    :items="corporateLabels"
                    :rules="[rules.required]"
                    class="required"
                    multiple small-chips outlined hide-details="auto">
                    <template v-slot:selection="{ item, parent, selected }">
                      <v-chip :input-value="selected" label small dark color="orange">
                        <span class="pr-2">{{ item.text }}</span>
                        <v-icon small @click="parent.selectItem(item)">fas fa-times</v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-combobox
                    ref="role"
                    label="権限（ロール）"
                    v-model="editedItem.role"
                    :items="roles"
                    :rules="[rules.required]"
                    class="required"
                    multiple small-chips outlined hide-details="auto">
                    <template v-slot:selection="{ item, parent, selected }">
                      <v-chip :input-value="selected" label small dark color="light-blue darken-3">
                        <span class="pr-2">{{ item }}</span>
                        <v-icon small @click="parent.selectItem(item)">fas fa-times</v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="3" class="pa-2">
                  <p class="label">アカウントの状態</p>
                  <toggle-button
                    v-model="editedItem.enabled"
                    :labels="{checked: '有効', unchecked: '無効'}"
                    color="#0277bd"
                    :value="editedItem.enabled"
                    :sync="true"
                    :width="70" :height="30" :font-size="14" />
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-textarea
                    ref="remarks"
                    label="備考"
                    v-model="editedItem.remarks"
                    rows="3"
                    outlined hide-details="auto">
                  </v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" text x-large>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { Auth, API, graphqlOperation } from 'aws-amplify'
import { createUser, updateUser, deleteUser } from '../graphql/mutations'
import { listUsers, listRoles, listAppOptions, listCorporates } from '../graphql/queries'
import { onCreateUser, onUpdateUser, onDeleteUser } from '../graphql/subscriptions'
import moment from 'moment'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '氏名', align: 'start', value: 'name' },
        { text: '所属部署', align: 'start', value: 'department' },
        { text: 'e-mail', align: 'start', value: 'email' },
        { text: '残有給日数', align: 'start', value: 'paidRemain' },
        { text: '使用済時間有給', align: 'start', value: 'paidHoursUsed' },
        { text: '所属企業', align: 'start', value: 'corporateIDs' },
        { text: '権限', align: 'start', value: 'role' },
        { text: '更新日時', align: 'start', value: 'updatedAt' },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      roles: [],
      corporates: [],
      editedIndex: -1,
      editedItem: { enabled: true },
      subscription: {},
      filterKeyword: {},
      birthday: false,
      joinDate: false,
      unitPrices: [],
      employmentTypes: [],
    }
  },
  prop: {},
  mounted: async function() {
    //roles query
    await this.getRoles()
    //corporate query
    await this.getCorporates()
    //users query
    await this.getUsers()
    //appOption query
    //一覧 query
    const query = await API.graphql(graphqlOperation(listAppOptions, {
      filter: {
        tag: { eq: 'appSetting' }
      },
      limit: 100,
    }))
    for (const row of query.data.listAppOptions.items) {
      switch (row.name) {
        case 'unitPrice':
          this.unitPrices = row.value.split(',')
          break
        case 'employmentType':
          this.employmentTypes = row.value.split(',')
          break
        default:
          break
      }
    }
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateUser)).subscribe({
      next: (e) => {
        const user = e.value.data.onCreateUser
        user.name = this.getFullname(user)
        this.desserts.push(user)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateUser)).subscribe({
      next: (e) => {
        const user = e.value.data.onUpdateUser
        user.name = this.getFullname(user)
        this.desserts.find(origin => {
          if (origin.id === user.id) {
            origin = Object.assign(origin, user)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteUser)).subscribe({
      next: (e) => {
        const user = e.value.data.onDeleteUser
        this.desserts = this.desserts.filter(origin => origin.id !== user.id)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      for (const item of this.desserts) {
        //氏名
        if (this.filterKeyword.name && item.name.indexOf(this.filterKeyword.name) < 0) continue
        map.push(item)
      }
      return map
    },
    existsEmail() {
      const user = this.desserts.find(e => e.email === this.editedItem.email)
      return (!user || user.id == this.editedItem.id) || 'このメールアドレスは使用されています'
    },
    departments() {
      const map = []

      for (const item of this.desserts) {
        if (item.department && !map.find(e => e == item.department)) map.push(item.department)
      }

      //名前順でソート
      map.sort(function(a,b) {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })

      return map
    },
    corporateLabels() {
      const map = []

      for (const item of this.corporates) {
        map.push({
          value: item.id,
          text: item.name,
        })
      }

      return map
    },
    form() {
      return {
        id: this.editedItem.id,
        first: this.editedItem.first,
        last: this.editedItem.last,
        email: this.editedItem.email,
        phone: this.editedItem.phone || null,
        birthday: this.editedItem.birthday || null,
        department: this.editedItem.department || null,
        director: this.editedItem.director || null,
        joinDate: this.editedItem.joinDate || null,
        unitPrice: this.editedItem.unitPrice ? parseInt(this.editedItem.unitPrice) : null,
        employmentType: this.editedItem.employmentType || null,
        paidRemain: this.editedItem.paidRemain != null ? parseFloat(this.editedItem.paidRemain) : null,
        paidHoursUsed: this.editedItem.paidHoursUsed != null ? parseInt(this.editedItem.paidHoursUsed) : null,
        dailyWorktime: this.editedItem.dailyWorktime != null ? parseInt(this.editedItem.dailyWorktime) : null,
        enabled: this.editedItem.enabled ? true : false,
        role: this.editedItem.role || [],
        corporateIDs: this.editedItem.corporateIDs || [],
        remarks: this.editedItem.remarks || null,
        widgets: this.editedItem.widgets || [],
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {

    },
    //行選択
    onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
      this.editedItem = Object.assign({}, params)
      delete this.editedItem.updatedAt
      delete this.editedItem.createdAt
      //所属法人
      const corporateIDs = []
      if (this.editedItem.corporateIDs) {
        for (const item of this.editedItem.corporateIDs) {
          const corporate = this.corporateLabels.find(e => e.value === item)
          if (corporate) corporateIDs.push(corporate)
        }
      }
      this.editedItem.corporateIDs = corporateIDs

      this.dialog = true
    },
    //保存
    async save() {
      //try {
        this.saving = true
        const user = this.form

        //delete user.passwd
        //delete user.name
        //user.unitPrice = user.unitPrice ? parseInt(user.unitPrice) : null
        
        //所属法人
        const corporateIDs = []
        for (const item of user.corporateIDs) {
          corporateIDs.push(item.value)
        }
        user.corporateIDs = corporateIDs

        // 不要な属性の削除
        // delete user.__typename
        for (const widget of user.widgets) {
          delete widget.__typename
        }

        //編集
        if (this.editedIndex >= 0) {
          await API.graphql(graphqlOperation(updateUser, {input: user}))
          this.log({ type: this.$route.name, text: user.last + user.first + ' を更新しました' })

        //新規
        } else {
          const cognito = await Auth.signUp({
            username: this.editedItem.email,
            password: this.editedItem.passwd,
          })
          user.id = cognito.userSub
          await API.graphql(graphqlOperation(createUser, {input: user}))
          this.log({ type: this.$route.name, text: user.last + user.first + ' を追加しました' })
        }
        //ロールに管理者が含まれているか
        if (user.role.find(e => e == '管理者')) {
          //Adminsグループに追加する
          await API.post(
            'AdminQueries', 
            '/addUserToGroup', 
            {
              body : {
                'username': user.id,
                'groupname': 'Admins'
              },
              headers: {
                'Content-Type' : 'application/json',
                Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
              }
            }
          )

        } else {
          //Adminsグループから外す
          await API.post(
            'AdminQueries', 
            '/removeUserFromGroup', 
            {
              body : {
                'username': user.id,
                'groupname': 'Admins'
              },
              headers: {
                'Content-Type' : 'application/json',
                Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
              }
            }
          )
        }

        this.dialog = false
        /*
      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }
      */
    },
    //確認メールの再送
    async resendConfirm() {
      try {
        if (window.confirm(this.editedItem.email + '宛に検証メールを再送しますか？')) {
          const session = await Auth.currentSession()
          //検証メールを再送
          await API.post(
            'AdminQueries', 
            '/resendConfirmationCode', 
            {
              body : {
                'clientId': session.accessToken.payload.client_id,
                'username': this.editedItem.id,
              },
              headers: {
                'Content-Type' : 'application/json',
                Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
              }
            }
          )
          this.myAlert('検証メールを再送しました', 'success')
        }
        
      } catch (error) {
        this.myAlert('このアカウントは既にメール検証済です')
      }
    },
    //削除
    async remove() {
      try {
        if (window.confirm(this.editedItem.name + 'を削除しますか？')) {
          //Usersからユーザーを削除
          const user = { id: this.editedItem.id }
          await API.graphql(graphqlOperation(deleteUser, {input: user}))
          //Cognitoからユーザーを削除
          await API.post(
            'AdminQueries', 
            '/deleteUser', 
            {
              body : {
                'username': this.editedItem.id,
              },
              headers: {
                'Content-Type' : 'application/json',
                Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
              }
            }
          )
          this.myAlert('アカウントを削除しました', 'success')
          this.dialog = false
        }
        
      } catch (error) {
        this.myAlert(error)
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f]) this.$refs[f].reset()
      })
      this.editedItem.id = null
      this.editedItem.enabled = true
    },
    //フルネーム
    getFullname(user) {
      return user.last + ' ' + user.first
    },
    //法人名の取得
    getCorporateLabel(value) {
      const corporate = this.corporateLabels.find(e => e.value === value)

      return corporate ? corporate.text : null
    },
    //年齢計算
    calcAge(date) {
      let from = parseInt(moment(date).format('YYYYMMDD'))
      let to = parseInt(moment().format('YYYYMMDD'))
      return Math.floor( (to - from) / 10000 )
    },
    //権限の取得
    async getRoles(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listRoles, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listRoles.items) {
        this.roles.push(data.name)
      }
      if (query.data.listRoles.nextToken) this.getRoles(query.data.listRoles.nextToken)
    },
    //法人の取得
    async getCorporates(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCorporates, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listCorporates.items) {
        this.corporates.push(data)
      }
      if (query.data.listCorporates.nextToken) {
        this.getCorporates(query.data.listCorporates.nextToken)
      } else {
        //フリガナ順でソート
        this.corporates.sort(function(a, b) {
          if (a.furigana < b.furigana) return -1
          if (a.furigana > b.furigana) return 1
          return 0
        })
      }
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        data.name = this.getFullname(data)
        this.desserts.push(data)
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
  },
}
</script>

<style lang='scss' scoped>

</style>
